import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild , Router } from "@angular/router";
import { Observable } from "rxjs/Observable";

@Injectable()
export class PatientPortalVerifyPinGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router
  ) { }

  canActivate() {
    let _patientPT = JSON.parse(sessionStorage.getItem("patientPT"));

    if (_patientPT === null) {
      this.router.navigate(["/patient-portal/phone"]);
      return false;
    }

    if (Object.keys(_patientPT.phoneNumber).length !== 3) {
      this.router.navigate(["/patient-portal/phone"]);
      return false;
    }

    return true;
  }

  canActivateChild() {
    return this.canActivate();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/patient-portal/patient-portal-verify-pin.guard.ts